/**
 * @generated SignedSource<<c05f0d5eaa7746a387fb754905b432ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type liveUpdateSwitchLiveArticleArticle$data = {
  readonly entityId: string;
  readonly " $fragmentType": "liveUpdateSwitchLiveArticleArticle";
};
export type liveUpdateSwitchLiveArticleArticle$key = {
  readonly " $data"?: liveUpdateSwitchLiveArticleArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"liveUpdateSwitchLiveArticleArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "liveUpdateSwitchLiveArticleArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "6e788bd3a2e594005b57f0e476b0dd37";

export default node;
